import { useEffect, useState } from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DemoBanner() {
  const { logout } = useAuth();
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/auth/signup-status").then(({ data }) => setOpen(data.open)).catch(() => setOpen(false)); }, []);

  const signUp = () => {
    sessionStorage.setItem("finlo_auth_tab", "register");
    logout();
  };

  return (
    <div data-testid="demo-banner" className="border-b border-[#00C896]/25 bg-[#00C896]/[0.08]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-xs sm:text-sm text-[#BFF5E6] min-w-0">
          <Sparkles className="h-4 w-4 text-[#00C896] shrink-0" />
          <span className="truncate"><span className="font-semibold text-white">You're exploring the demo.</span><span className="hidden sm:inline"> Sample data only.</span></span>
        </p>
        {open && (
          <button data-testid="demo-banner-signup-button" onClick={signUp}
            className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#00C896] hover:bg-[#00E5AC] px-3 sm:px-3.5 py-1 text-xs font-semibold text-[#04140D] transition-colors">
            Create your free account <ArrowRight className="h-3.5 w-3.5 hidden sm:block" />
          </button>
        )}
        {open === false && (
          <span data-testid="demo-banner-coming-soon"
            className="shrink-0 rounded-full border border-[#00C896]/40 px-3 py-1 text-xs font-semibold text-[#4DE3BF]">
            Sign-ups coming soon
          </span>
        )}
      </div>
    </div>
  );
}
